<script setup lang="ts">
/** TMP082 — Subscription / Application for Shares (Corporate Subscriber, "We").
 *  변수 집합은 TMP081과 동일. 토글: has_constitution, is_politician, is_pep_connected, holds_govt_position, is_trustee. */
import { computed, inject } from 'vue';
import { OTC_DOC_CTX } from './otcContext';
import OtcDocVarField from './OtcDocVarField.vue';
import OtcSigners from './parts/OtcSigners.vue';

const ctx = inject(OTC_DOC_CTX)!;
const hasConstitution = computed(() => ctx.flag('has_constitution'));
</script>

<template>
  <div class="allot-doc">
    <div class="doc-head">
      <div class="doc-company">APPLICATION / SUBSCRIPTION FOR SHARES</div>
      <div class="doc-meta">(Corporate Subscriber)</div>
    </div>

    <p class="doc-p"><b>Date:</b> <OtcDocVarField field-key="letter_date" /></p>
    <p class="doc-p">To the Board of Directors of <OtcDocVarField field-key="company_name" /></p>
    <p class="doc-p">Registered Office: <OtcDocVarField field-key="company_address" /></p>
    <p class="doc-p">
      We, <OtcDocVarField field-key="subscriber_name" /> [Registration No.
      <OtcDocVarField field-key="subscriber_id" />], of
      <OtcDocVarField field-key="subscriber_address" />, hereby apply to subscribe for
      <OtcDocVarField field-key="shares_subscribed" /> ordinary shares of RM<OtcDocVarField field-key="share_price" />
      each in the Company, and request that the said shares be allotted to us in accordance with the
      <span class="doc-toggle" title="Constitution / Articles of Association" @click="ctx.toggleFlag('has_constitution')">{{ hasConstitution ? 'Constitution' : 'Articles of Association' }}</span>
      of the Company.
    </p>

    <p class="doc-lbl-title">Subscriber Particulars</p>
    <table class="cdd-tbl">
      <tbody>
        <tr><td class="cdd-lcell">Subscriber Type</td><td><OtcDocVarField field-key="subscriber_type" /></td></tr>
        <tr><td class="cdd-lcell">Occupation / Nature of Business</td><td><OtcDocVarField field-key="subscriber_occupation" /></td></tr>
        <tr><td class="cdd-lcell">Date of Incorporation</td><td><OtcDocVarField field-key="subscriber_dob" /></td></tr>
        <tr><td class="cdd-lcell">Nationality / Place of Incorporation</td><td><OtcDocVarField field-key="subscriber_nationality" /></td></tr>
        <tr><td class="cdd-lcell">Race</td><td><OtcDocVarField field-key="subscriber_race" /></td></tr>
      </tbody>
    </table>

    <p class="doc-lbl-title">KYC / PEP Declaration</p>
    <p class="doc-p">
      <span class="doc-toggle" @click="ctx.toggleFlag('is_politician')">{{ ctx.flag('is_politician') ? '✓ a director / controller is a politician or holds public office' : '☐ a director / controller is a politician or holds public office' }}</span>
      <template v-if="ctx.flag('is_politician')"> — <OtcDocVarField field-key="politician_details" /></template>
    </p>
    <p class="doc-p">
      <span class="doc-toggle" @click="ctx.toggleFlag('is_pep_connected')">{{ ctx.flag('is_pep_connected') ? '✓ connected to a PEP' : '☐ connected to a PEP' }}</span>
      <template v-if="ctx.flag('is_pep_connected')"> — <OtcDocVarField field-key="pep_connection_details" /></template>
    </p>
    <p class="doc-p">
      <span class="doc-toggle" @click="ctx.toggleFlag('holds_govt_position')">{{ ctx.flag('holds_govt_position') ? '✓ holds a government position' : '☐ holds a government position' }}</span>
      <template v-if="ctx.flag('holds_govt_position')"> — <OtcDocVarField field-key="govt_position_details" /></template>
    </p>
    <p class="doc-p">
      <span class="doc-toggle" @click="ctx.toggleFlag('is_trustee')">{{ ctx.flag('is_trustee') ? '✓ subscribing as trustee' : '☐ subscribing as trustee' }}</span>
    </p>

    <p class="doc-lbl-title">Beneficial Owner</p>
    <table class="cdd-tbl">
      <tbody>
        <tr><td class="cdd-lcell">Beneficial Owner Name</td><td><OtcDocVarField field-key="bo_full_name" /></td></tr>
        <tr><td class="cdd-lcell">Nature of Control</td><td><OtcDocVarField field-key="bo_nature" /></td></tr>
        <tr><td class="cdd-lcell">Place</td><td><OtcDocVarField field-key="bo_place" /></td></tr>
        <tr><td class="cdd-lcell">Registration No.</td><td><OtcDocVarField field-key="bo_registration_no" /></td></tr>
        <tr><td class="cdd-lcell">Registered Address</td><td><OtcDocVarField field-key="bo_registered_address" /></td></tr>
        <tr><td class="cdd-lcell">Business Address</td><td><OtcDocVarField field-key="bo_business_address" /></td></tr>
      </tbody>
    </table>

    <p class="doc-p" style="margin-top:12px">
      No. of Shares Offered: <OtcDocVarField field-key="shares_offered" /> &nbsp;·&nbsp;
      No. of Shares Accepted: <OtcDocVarField field-key="shares_accepted" />
    </p>

    <p class="doc-p"><span class="cdd-cbx"><span class="box">☐</span>We confirm that the information provided is accurate and complete.</span></p>
    <p class="doc-p"><span class="cdd-cbx"><span class="box">☐</span>We are not a sanctioned person and the source of funds is legitimate.</span></p>
    <p class="doc-p"><span class="cdd-cbx"><span class="box">☐</span>We consent to the processing of the personal data provided herein.</span></p>

    <p class="doc-lbl-title">Signed for and on behalf of the Corporate Subscriber</p>
    <OtcSigners var-key="subscription" />
  </div>
</template>
